import configJson from "./auth_config.json";

// WHY auth_config.json MIXES TWO HOSTNAMES - do not "tidy" this into one.
//
//   domain    auth.ninjaskiptracing.com                              (custom domain)
//   audience  https://dev-t8ituz8ye8noyowf.us.auth0.com/api/v2/      (canonical tenant)
//
// An Auth0 API identifier is a fixed string, not a URL that gets resolved, and it does NOT
// change when a custom domain is added - the Management API keeps the canonical tenant host
// forever. Rewriting the audience to the custom domain requests an API that does not exist,
// and getAccessTokenSilently then fails for every user.
//
// The rule is: authenticate against the custom domain, ask for the canonical audience, and
// call API endpoints on whichever domain issued the token.
export function getConfig() {
  // Configure the audience here. By default, it will take whatever is in the config
  // (specified by the `audience` key) unless it's the default value of "YOUR_API_IDENTIFIER" (which
  // is what you get sometimes by using the Auth0 sample download tool from the quickstart page, if you
  // don't have an API).
  // If this resolves to `null`, the API page changes to show some helpful info about what to do
  // with the audience.
  const audience =
    configJson.audience && configJson.audience !== "YOUR_API_IDENTIFIER"
      ? configJson.audience
      : null;

  return {
    domain: configJson.domain,
    clientId: configJson.clientId,
    ...(audience ? { audience } : null),
  };
}
